<template>
  <multi-selection-tool-button
    icon="mdi-checkbox-multiple-marked"
    :disabled="disabled"
    :tooltip="$t('SelectAll')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableSelectAllTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/SelectAll.vue